export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/dashboard/~/d3-shape/src/constant.js
// module id = ../../../dashboard/node_modules/d3-shape/src/constant.js
// module chunks = 1